export const months = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Aôut',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export const days = [
  { full: 'Dimanche', abbr: 'Dim' },
  { full: 'Lundi', abbr: 'Lun' },
  { full: 'Mardi', abbr: 'Mar' },
  { full: 'Mercredi', abbr: 'Mer' },
  { full: 'Jeudi', abbr: 'Jeu' },
  { full: 'Vendredi', abbr: 'Ven' },
  { full: 'Samedi', abbr: 'Sam' },
];
